// extracted by mini-css-extract-plugin
export default {"line-through":"channel-provider_line-through__8+ZRp"};